module.exports = __webpack_public_path__ + "img/IMG_8941.49d79400.jpg";